import { observer, useLocalStore } from 'mobx-react-lite';
import React, { useContext } from 'react';
import { UsersContext } from '../../contexts/Users';
import AssessmentCard from '../admin/AssessmentCard';
import AddAssessment from './AddAssessment';
import * as CSS from './elements/StaffStudentAssessments';

const StaffStudentAssessments = observer(({ studentId }) => {
  const usersStore = useContext(UsersContext);
  const student = usersStore.getUserById(studentId);
  const store = useLocalStore(() => ({
    isFormOpen: false,
  }));

  const currentAssessment = student?.private.getActiveAssessmentByCategory(
    usersStore.getLoggedInUser().selectedCategory
  );
  const archivedAssessments = student?.private.getArchivedAssessments(
    usersStore.getLoggedInUser().selectedCategory
  );

  const currentAssessmentUnCheckedCount = currentAssessment?.getTotalUnchecked(
    usersStore.loggedInUserId
  );

  return (
    <CSS.AssessmentSections
      data-testid={`StaffStudentAssessments-${student?.displayName}`}
    >
      <CSS.Panel>
        <CSS.PanelHeader>
          <CSS.AssessmentTitle>Active Learning Plan</CSS.AssessmentTitle>
        </CSS.PanelHeader>
        {store.isFormOpen ? (
          <AddAssessment
            studentId={studentId}
            onClose={() => (store.isFormOpen = false)}
          />
        ) : (
          <CSS.AssessmentList>
            {currentAssessment && (
              <CSS.StaffCardNotification
                badgeContent={currentAssessmentUnCheckedCount}
                data-testid={`unread-count-${currentAssessment.id}`}
              >
                <AssessmentCard
                  assessment={currentAssessment}
                  studentId={studentId}
                  hasNotifications
                  as="div"
                />
              </CSS.StaffCardNotification>
            )}
            <CSS.AddCard>
              <CSS.CreateAssessmentButton
                aria-label="create assessment"
                onClick={() => (store.isFormOpen = true)}
              >
                <CSS.PlusIcon style={{ fontSize: '2.4rem' }} />
                New learning plan
              </CSS.CreateAssessmentButton>
            </CSS.AddCard>
          </CSS.AssessmentList>
        )}
      </CSS.Panel>
      <CSS.Panel>
        <CSS.PanelHeader>
          <CSS.AssessmentTitle>Archived Learning Plans</CSS.AssessmentTitle>
        </CSS.PanelHeader>
        {archivedAssessments?.length ? (
          <CSS.AssessmentList>
            {archivedAssessments.map((assessment) => (
              <AssessmentCard
                assessment={assessment}
                key={assessment.id}
                studentId={studentId}
                archived={true}
              />
            ))}
          </CSS.AssessmentList>
        ) : (
          <CSS.PanelEmpty>No archived learning plans</CSS.PanelEmpty>
        )}
      </CSS.Panel>
    </CSS.AssessmentSections>
  );
});

export default StaffStudentAssessments;
